import { HeaderComponent } from './header/header.component';
import { Component, Inject, Input } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from './footer/footer.component';
import { AuthService } from '@auth0/auth0-angular';

@Component({
  selector: 'out-default',
  imports: [CommonModule, RouterOutlet, HeaderComponent, FooterComponent],
  templateUrl: './default.component.html',
  styleUrl: './default.component.scss',
})
export class DefaultComponent {
  @Input() logoSrc = '/assets/images/out-horizontal-logo.svg';
  @Input() footerLogoSrc = '/assets/images/out-horizontal-white.svg';
  @Input() sideLogoSrc = '/assets/images/sidebar-logo.svg';
  isAuthenticated = true;

  constructor(
    public auth: AuthService,
    @Inject(DOCUMENT) public document: Document
  ) {}

  menuItems = [
    {
      label: 'Used Tesla For Sale',
      url: '/used-tesla-for-sale',
      initialQueryParams: { OrderBy: 'created DESC', Skip: '0', Top: '9' },
    },
    { label: 'About', url: '/about-only-used-tesla' },
    /* { label: 'Blog', url: 'https://blog.onlyusedtesla.com', external: true }, */
    { label: 'My Dashboard', url: '/account', auth: true },
    { label: 'Sell My Tesla', url: '/your-tesla', auth: true },
    { label: 'Sell My Tesla', url: '/sell-my-tesla', auth: false },
    { label: 'FAQ', url: '/frequently-asked-questions' },
    { label: 'Contact', url: '/contact' },
    { label: 'Log In', url: '#', click: () => this.login(), auth: false },
    { label: 'Log Out', url: '#', click: () => this.logout(), auth: true },
    {
      label: 'Register',
      url: '#',
      click: () => this.login(),
      auth: false,
      isRegister: true,
    },
  ];

  navLinks = [
    {
      label: 'Sell My Tesla',
      url: '/your-tesla',
      auth: true,
    },
    {
      label: 'Sell My Tesla',
      url: '/sell-my-tesla',
      auth: false,
    },
    {
      label: 'Used Tesla For Sale',
      url: '/used-tesla-for-sale',
      initialQueryParams: { OrderBy: 'created DESC', Skip: '0', Top: '9' },
    },
    { label: 'My Dashboard', url: '/account', auth: true },
    { label: 'About', url: '/about-only-used-tesla' },
    /* { label: 'Blog', url: 'https://blog.onlyusedtesla.com', external: true }, */
    { label: 'FAQ', url: '/frequently-asked-questions' },
    { label: 'Contact', url: '/contact' },
    // {
    //   label: 'Log In',
    //   url: '#',
    //   click: () => this.login(),
    //   auth: false
    // },
    {
      label: 'Log Out',
      url: '#',
      click: () => this.logout(),
      auth: true,
      isLogout: true,
    },
    // {
    //   label: 'Register',
    //   url: '#',
    //   click: () => this.login(),
    //   auth: false,
    //   isRegister: false,
    // },
  ];

  login() {
    this.auth.loginWithRedirect();
  }

  logout() {
    this.auth.logout({
      logoutParams: {
        returnTo: `${window.location.origin}/logout`,
      },
    });
  }
}
